<div>
  <sh-modal
    id="isNoDataFound"
    class="modals"
    icon="information"
    type="information"
    label="{{ 'label.noDataFound' | translate }}"
    modal-height="140px"
    modal-width="400px"
  >
    <sh-text size="body-1">
      {{ 'message.noDataFound' | translate }}
    </sh-text>
  </sh-modal>
</div>

<div>
  <sh-modal
    id="isNotSupportedSystem"
    class="modals"
    icon="information"
    type="information"
    label="{{ 'label.notSupportedTubes' | translate }}"
    modal-height="140px"
    modal-width="500px"
  >
    <sh-text size="body-1" [innerHTML]="systemNotSupported">
      {{ systemNotSupported }}
    </sh-text>
  </sh-modal>
</div>

<sh-modal
  id="malformedIdentifier"
  class="modals"
  icon="error"
  type="information"
  label="{{ 'label.error' | translate }}"
  modal-height="140px"
  modal-width="400px"
>
  <sh-text size="body-1">
    <p>
      {{ 'message.error.malformedIdentifier' | translate }}
      <a [href]="getSeSoMailAddress()"> SeSO Team </a>
    </p>
  </sh-text>
</sh-modal>

<sh-modal
  id="isInternalServerError"
  class="modals"
  icon="error"
  type="information"
  label="{{ 'label.error' | translate }}"
  modal-height="140px"
  modal-width="400px"
>
  <sh-text size="body-1">
    <p>
      {{ 'message.error.internalServerError' | translate }}
      <a [href]="getSeSoMailAddress()"> SeSO Team </a>
    </p>
  </sh-text>
</sh-modal>

<sh-modal
  id="isUnauthorized"
  class="modals"
  icon="error"
  type="information"
  label="Error"
  modal-height="180px"
  modal-width="500px"
>
  <sh-text size="body-1">
    <p>
      {{ 'message.error.notLoggedIn' | translate }}
    </p>
  </sh-text>
</sh-modal>

<sh-modal
  id="isForbidden"
  class="modals"
  icon="error"
  type="information"
  label="{{ 'label.error' | translate }}"
  modal-height="180px"
  modal-width="500px"
>
  <sh-text size="body-1">
    <p>
      {{ 'message.error.forbiddenPt1' | translate
      }}{{ 'message.error.forbiddenPt2' | translate }}
      <a
        href="mailto:seso.team@siemens-healthineers.com?subject=SeSO%20Tube%20Companion%20reports%20that%20the%20user%20is%20not%20authorized"
      >
        SeSO Team</a
      >
      {{ 'message.error.forbiddenPt3' | translate }}
    </p>
  </sh-text>
</sh-modal>
@if (announcementService.activeAnnouncement$ | async; as announcement) {
  <sh-notification-item
    visible
    inline
    [type]="announcement.type"
    (close)="announcementService.closeAnnouncement(announcement.indexIncrement)"
    [innerHTML]="announcement.message | sanitizeHtml"
  ></sh-notification-item>
}

<router-outlet></router-outlet>
